import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

function NavBar() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!isOpen) return undefined;

    const closeOnEscape = (event) => {
      if (event.key === 'Escape') setIsOpen(false);
    };

    document.addEventListener('keydown', closeOnEscape);
    return () => document.removeEventListener('keydown', closeOnEscape);
  }, [isOpen]);

  const closeDrawer = () => setIsOpen(false);

  return (
    <>
      <header className="site-header">
        <Link to="/" className="site-heading" onClick={() => window.scrollTo(0, 0)} aria-label="Go to home grid">
          <span className="site-name">KENNETH NGUYEN</span>
          <span className="site-subtitle">FILM PORTFOLIO</span>
        </Link>
      </header>
      <button
        className="menu-toggle"
        type="button"
        aria-label={isOpen ? 'Close navigation menu' : 'Open navigation menu'}
        aria-expanded={isOpen}
        aria-controls="site-navigation"
        onClick={() => setIsOpen((open) => !open)}
      >
        <span />
        <span />
        <span />
      </button>
      {isOpen && (
        <>
          <button
            className="navigation-backdrop"
            type="button"
            aria-label="Close navigation menu"
            onClick={closeDrawer}
          />
          <nav className="side-navigation" id="site-navigation" aria-label="Main navigation">
            <Link to="/#films" onClick={closeDrawer}>Films</Link>
            <Link to="/#commercial" onClick={closeDrawer}>Commercial</Link>
            <Link to="/about" onClick={closeDrawer}>About</Link>
          </nav>
        </>
      )}
    </>
  );
}

export default NavBar;

